import { render, staticRenderFns } from "./CepInstructions.vue?vue&type=template&id=64b74548&scoped=true&"
import script from "./CepInstructions.vue?vue&type=script&lang=js&"
export * from "./CepInstructions.vue?vue&type=script&lang=js&"
import style0 from "./CepInstructions.vue?vue&type=style&index=0&id=64b74548&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b74548",
  null
  
)

export default component.exports